import AlertBanner from '../ui/AlertBanner'
import { i18n } from '@lingui/core'

export const AlertBannerUnexpectedError = ({
  errorCode,
}: {
  errorCode: string | string[] | undefined | null
}) => {
  const displayErrorCode = Array.isArray(errorCode) ? errorCode[0] : errorCode

  return (
    <AlertBanner
      title={i18n._('Uuups... da ist was schief gelaufen. Wir bitten um Entschuldigung!')}
      className="my-6"
    >
      <>
        <p>{i18n._('Bitte prüfen Sie zuerst Ihre Angaben auf Richtigkeit.')}</p>
        <br />
        <p>
          {i18n._(
            'Im Zweifel versuchen Sie es später erneut oder wenden Sie sich in dringenden Fällen mit dem Fehlercode'
          )}{' '}
          "{displayErrorCode}" {i18n._('telefonisch unter der')}{' '}
          <a className="font-bold" href="tel:+4989889498525">
            089 - 88 949 85 25
          </a>{' '}
          {i18n._('oder per Mail an')}{' '}
          <a className="font-bold" href="mailto:feedback@bpam.info">
            feedback@bpam.info
          </a>{' '}
          {i18n._('an uns.')}
        </p>
      </>
    </AlertBanner>
  )
}
